import { AccessSetting as AccessSettingV2 } from 'types/graphql';

export type AccessSetting = 'anyone' | 'anyone-details' | 'specify';

interface AccessSettingsProps {
  allowedEmailAddressesOnly: boolean;
  allowAnonymous: boolean;
}

export function getAccessSetting({ allowAnonymous, allowedEmailAddressesOnly }: AccessSettingsProps): AccessSetting {
  if (allowAnonymous) return 'anyone';
  if (allowedEmailAddressesOnly) return 'specify';
  return 'anyone-details';
}

export function getAccessSettingV2(accessSetting: AccessSettingV2): AccessSetting {
  switch (accessSetting) {
    case AccessSettingV2.Anyone:
      return 'anyone';
    case AccessSettingV2.AllowedEmailsOnly:
      return 'specify';
    case AccessSettingV2.AnyoneLeavingDetails:
      return 'anyone-details';
  }
}
